const Analytics = () => {
  return (
    <div className="fade-in">
      <h1 style={{ color: 'var(--text-primary)', marginBottom: '2rem' }}>
        📈 Analytics & Insights
      </h1>
      <div style={{
        background: 'var(--bg-card)',
        border: '1px solid var(--border-color)',
        borderRadius: '16px',
        padding: '3rem',
        textAlign: 'center'
      }}>
        <div style={{ fontSize: '4rem', marginBottom: '1rem' }}>🚧</div>
        <h2 style={{ color: 'var(--text-primary)', marginBottom: '1rem' }}>
          Analytics Dashboard Coming Soon
        </h2>
        <p style={{ color: 'var(--text-secondary)' }}>
          Detailed insights and analytics will be available here.
        </p>
      </div>
    </div>
  )
}

export default Analytics
